import { render, staticRenderFns } from "./EditorTooltip.vue?vue&type=template&id=3a8cd196&scoped=true&"
import script from "./EditorTooltip.vue?vue&type=script&lang=ts&"
export * from "./EditorTooltip.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8cd196",
  null
  
)

export default component.exports